module.exports = __webpack_public_path__ + "img/p21.e21a0719.gif";